import { Routes } from '@angular/router';
import { DesktopWebPropertyListComponent } from '../pages/desktop-web-property-list/desktop-web-property-list.component';

export let DESKTOP_WEB_PROPERTY_LIST_ROUTES: Routes = [
  {
    path: '',
    component: DesktopWebPropertyListComponent,
    /*loadComponent: () =>
      import(
        '../pages/mobile-web-property-list/mobile-web-property-list.component'
      ).then((m) => m.MobileWebPropertyListComponent),*/
  },
];
